import React from 'react'

import Reviews from 'js/components/Reviews/Reviews'

function MealPlansPageReviews() {
  return (
    <section className="pb-64 pt-64">
      <div className="mx-auto w-full max-w-1440 px-32">
        <Reviews />
      </div>
    </section>
  )
}

export default MealPlansPageReviews
